if (!customElements.get('jk-upsell-button')) {
  customElements.define(
    'jk-upsell-button',
    class JkUpsellButton extends HTMLElement {
      connectedCallback() {
        this._btn = this.querySelector('button');
        if (this._btn) {
          this._btn.addEventListener('click', this._onAdd.bind(this));
        }
      }

      async _onAdd() {
        const variantId = this.dataset.variantId;
        if (!variantId) return;

        const label      = this.dataset.btnLabel || 'Add';
        const isCartPage = window.location.pathname.startsWith('/cart');

        this._btn.disabled  = true;
        this._btn.textContent = '…';

        try {
          const sectionsToFetch = isCartPage
            ? ['cart-icon-bubble']
            : ['cart-drawer', 'cart-icon-bubble'];

          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id:       parseInt(variantId, 10),
              quantity: 1,
              sections: sectionsToFetch
            })
          });

          if (!resp.ok) throw new Error(`add failed: ${resp.status}`);

          const data     = await resp.json();
          const sections = data.sections || {};

          if (isCartPage) {
            /* Reload so cart items, totals, and recommendations all update */
            window.location.reload();
            return;
          }

          if (sections['cart-drawer']) {
            const tmp = document.createElement('div');
            tmp.innerHTML = sections['cart-drawer'];
            const newInner       = tmp.querySelector('.drawer__inner');
            const existingInner  = document.querySelector('.cart-drawer .drawer__inner');
            if (newInner && existingInner) existingInner.replaceWith(newInner);
          }

          if (sections['cart-icon-bubble']) {
            const tmp = document.createElement('div');
            tmp.innerHTML = sections['cart-icon-bubble'];
            const newBubble      = tmp.querySelector('#cart-icon-bubble');
            const existingBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && existingBubble) existingBubble.replaceWith(newBubble);
          }
        } catch (_err) {
          this._btn.disabled    = false;
          this._btn.textContent = label;
        }
      }
    }
  );
}
